<script setup lang="ts">
import { useConnectionStatusBanner } from './connection-status-banner';
import { ConnectionStatusBannerTemplate } from './templates';

const { status, isVisible, label } = useConnectionStatusBanner();
</script>

<template>
  <Transition
    enter-active-class="transition-[transform,opacity] duration-200 ease-out"
    enter-from-class="-translate-y-2 opacity-0"
    enter-to-class="translate-y-0 opacity-100"
    leave-active-class="transition-[transform,opacity] duration-150 ease-in"
    leave-from-class="translate-y-0 opacity-100"
    leave-to-class="-translate-y-2 opacity-0"
  >
    <ConnectionStatusBannerTemplate
      v-if="isVisible"
      :status="status"
      :label="label"
    />
  </Transition>
</template>
